module.exports = __webpack_public_path__ + "img/beefeater-age-confirm-logo.6a0bb11f.svg";